import W from '@wamms/tinylib'

export default {
	init() {
		// fade offset
		let fadeOffset = 50

		// setup intersection observer for text elements
		let txtObserver = new IntersectionObserver( entries => {
			entries.forEach( entry => {
				let a = entry.target.dataset.anim
				if ( a === 'fade' ) {
					entry.target.style.opacity = entry.isIntersecting ? 1 : 0
				} else if ( a === 'flip' || a === 'slide' ) {
					entry.target.dataset.status = entry.isIntersecting ? 'visible' : 'hidden'
				}
			} )
		}, {
			root: 		null,
			rootMargin: `9999px 0px -${ fadeOffset }px 0px`,
			threshold:  1.0
		} )

		// setup intersection observer for image elements
		let imgObserver = new IntersectionObserver( entries => {
			entries.forEach( entry => {
				let a = entry.target.dataset.anim
				if ( a === 'fade' ) {
					entry.target.dataset.status = entry.isIntersecting ? 'visible' : 'hidden'
				} else if ( a === 'slide' ) {
					if ( entry.isIntersecting ) {
						entry.target.dataset.status = 'visible'
					}
				}
			} )
		}, {
			root: 		null,
			rootMargin: `9999px 0px 0px 0px`,
			threshold:  0.35
		} )

		// convert titles to spans and observe their parents
		this.splitSpace( '.member-title, .contact-title' )
		for ( let e of W.sel( '.member-title, .contact-title' ) ) {
			txtObserver.observe( e )
		}

		// split text into words and observe the spans
		this.splitSpace( '.studio-info, .member-info, .contact-info', 'fade' )
		for ( let e of W.sel( '.studio-info span, .member-info span, .contact-info span' ) ) {
			txtObserver.observe( e )
		}

		// observe social links
		for ( let e of W.sel( '.contact-social' ) ) {
			txtObserver.observe( e )
		}

		// observe gallery slide
		for ( let e of W.sel( '.gallery-container' ) ) {
			imgObserver.observe( e )
		}

		// observe member images
		for ( let e of W.sel( '.member-image' ) ) {
			imgObserver.observe( e )
		}
	},

	// split text into word spans
	// s ..... selector
	// a ..... animation type
	splitSpace( s, a = null ) {
		for ( let e of W.sel( s ) ) {
			this.splitSpaceElement( e, a )
		}
	},

	splitSpaceElement( e, a = null ) {
		if ( e.nodeName === '#text' ) {
			// always start text nodes with space except for single chars
			if ( e.data.trim().length > 1 ) {
				e.parentNode.insertBefore( document.createTextNode( ' ' ), e )
			}

			let words = e.data.split( ' ' )
			words.forEach( ( w, i ) => {
				if ( ( w = w.trim() ) !== '' ) {
					let d = W.new( 'span' )
					d.append( document.createTextNode( w ) )
					if ( a ) {
						d.dataset.anim = a
					}
					e.parentNode.insertBefore( d, e )

					// if this is not the last text node, end with space
					if ( i + 1 < words.length ) {
						e.parentNode.insertBefore( document.createTextNode( ' ' ), e )
					}
				}
			} )

			// remove the old node
			e.remove()
		} else {
			let node = e.firstChild;
			while ( node ) {
				// save the next node since the current one will be removed
				let next = node.nextSibling

				this.splitSpaceElement( node, a )
				node = next
			}
		}
	}
}